import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import {
  faArrowDown,
  faCalendar,
  faCommentSms,
  faEnvelope,
  faMagnifyingGlass,
  faPhone,
  faPlay,
  faSpinner,
  faUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { Row } from "react-bootstrap";
import timezones from "../Builder/nodes/Logic/timezones";
import ProjectStartForm from "../Builder/Components/sidebar/ProjectStartForm";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import TickIcon from "../../assets/icons/tick.svg2";
import TemplateDetail from "./TemplateDetail";
import { isUserPermitted } from "../helpers/pageProps";
import MyModal from "../Common/MyModal";
import ProjectInputVariables from "../Common/ProjectInputVariables";
import ProjectExportModal from "../Builder/Components/ProjectExportModal";
import { toast } from "react-toastify";
import { useDeleteProjectMutation } from "../store/slices/settingsSlice";
import HelpButton from "../HelpContent/HelpButton";
import ScheduleSettings from "../Schedulers/ScheduleSettings";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

const inboundIcons = {
  sms: <FontAwesomeIcon icon={faCommentSms} />,
  email: <FontAwesomeIcon icon={faEnvelope} />,
  voice: <FontAwesomeIcon icon={faPhone} />,
};

export default function ComponentDetails({ project }) {
  const { countries, defaultTZ, emailDomain } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;
  const confirmDialog = useConfirmDialog();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [deleteProject] = useDeleteProjectMutation();

  return (
    <div className="my-3">
      <div
        className={` w-75 h-100 px-0  text-start rounded-3 position-relative `}
      >
        <div className="d-flex align-items-center">
          <div className="bg-purple-gradient rounded-circle me-3">
            <EngineerVisitIcon width={60} />
          </div>
          <div className="me-3">
            <div className="d-flex align-items-center">
              <h3 className="m-0 fw-bold">
                {project.Label}

                {/* {project.isLogicReady ? (
              <span className=" fw-bold bg-info rounded-pill text-white ms-2 px-2 py-1 text-xs">
                <LogicIcon width={20} className="white " /> LOGIC READY
              </span>
            ) : (
              ""
            )} */}
              </h3>
              {project.SolutionUuid && (
                <span className="badge bg-secondary ms-2">Imported</span>
              )}
              {project.IsSolution === true && (
                <span className="badge bg-secondary ms-2">Template</span>
              )}
            </div>
            <div className="text-secondary  text-xxl-start text-break">
              <span className="fw-light"> Description: </span>
              {project.Description}
            </div>
          </div>
        </div>
      </div>
      <div className="fw-bold my-4">
        This component will setup the following for you:
      </div>
      <Row>
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Reference"
            value={project.Reference}
          />
        </div>
        {project.IsSingleton && (
          <div className="col-lg-6">
            <TemplateDetail
              Icon={TickIcon}
              label="Allow only one instance running"
              value={project.IsSingleton ? "Yes" : "No"}
            />
          </div>
        )}
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Created at"
            value={new Date(project.CreatedAt).toLocaleString()}
          />
        </div>
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Created by"
            value={project.CreatedBy}
          />
        </div>
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Status"
            value={project.Status}
          />
        </div>
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Country"
            value={
              countries.find((c) => c.country_code === project.CountryISO)
                ?.country_name
            }
          />
        </div>
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Time zone"
            value={
              project.TimeZone
                ? timezones.find((t) => t.tzCode === project.TimeZone)?.label
                : `${
                    timezones.find((t) => t.tzCode === defaultTZ)?.label
                  } (Default)`
            }
          />
        </div>
        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Processes"
            value={
              <span>
                {project.ActiveProcessCount}{" "}
                <Link
                  to={`/reporting/processes/${project.ID}`}
                  className="ms-2"
                >
                  <FontAwesomeIcon
                    icon={faUpRightFromSquare}
                    className="me-2"
                  />
                </Link>
              </span>
            }
          />
        </div>

        <div className="col-lg-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Last run at"
            value={
              project.LastRunAt === "0001-01-01T00:00:00Z"
                ? "N/A"
                : new Date(project.LastRunAt).toLocaleString()
            }
          />
        </div>
        {project.InboundRules &&
          project.InboundRules.map((r) => (
            <p className="row" key={r.ID}>
              <span className="col">Inbound</span>{" "}
              <span className="col-8">
                {inboundIcons[r.Channel]} {r.Inbound}
                {r.Channel === "email" ? `@${emailDomain}` : ""}
              </span>
            </p>
          ))}
      </Row>

      {/* <div className="fw-bold mt-4 pt-2">Please note:</div>
      <span className="text-secondary">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </span> */}
      {isUserPermitted("expert_logic_view") && (
        <>
          <div className="row justify-content-center g-2 my-4">
            <div className="col-lg-auto">
              <Link
                to={`/library/logic/builder/${project.ID}`}
                className="btn bg-colored-reverse rounded-pill"
              >
                <div className="d-flex align-items-center ">
                  <TickIcon width={25} className=" white rounded-circle p-1" />
                  <h5 className="my-0 mx-2  text-white">View</h5>
                </div>
              </Link>
            </div>
            <div className="col-lg-auto">
              <MyModal
                heading={
                  <>
                    API payload example{" "}
                    <HelpButton helpKey="api-payload-example" />
                  </>
                }
                size="lg"
                label={
                  <div className="d-flex align-items-center ">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />{" "}
                    <h5 className="my-0 mx-2  text-white">
                      API payload example
                    </h5>
                  </div>
                }
                buttonClassName="btn bg-colored-reverse rounded-pill d-inline-block p-2 px-3 text-white fs-5 h-100"
              >
                <ProjectInputVariables uuid={project.UUID} />
              </MyModal>
            </div>
            {project.Status === "production" && (
              <div className="col-lg-auto">
                <MyModal
                  heading={
                    <span>
                      Start this component{" "}
                      <HelpButton helpKey="start-component" />
                    </span>
                  }
                  size="lg"
                  label={
                    <div className="d-flex align-items-center ">
                      <FontAwesomeIcon icon={faPlay} />{" "}
                      <h5 className="my-0 mx-2  text-white">Start</h5>
                    </div>
                  }
                  buttonClassName="btn bg-colored-reverse rounded-pill d-inline-block p-2 px-3 text-white fs-5 h-100"
                >
                  <ProjectStartForm
                    projectID={project.ID}
                    showHiddenVariables
                    showSchedule
                  />
                </MyModal>
              </div>
            )}

            <div className="col-lg-auto">
              <MyModal
                heading={
                  <span>
                    Export this component{" "}
                    <HelpButton helpKey="export-component" />
                  </span>
                }
                size="lg"
                label={
                  <div className="d-flex align-items-center ">
                    <FontAwesomeIcon icon={faArrowDown} />{" "}
                    <h5 className="my-0 mx-2  text-white">Export component</h5>
                  </div>
                }
                buttonClassName="btn bg-colored-reverse rounded-pill d-inline-block p-2 px-3 text-white fs-5 h-100"
              >
                <ProjectExportModal
                  projectId={project.ID}
                  projectName={project.Label}
                />
              </MyModal>
            </div>
          </div>
          <div className="d-flex justify-content-center my-2">
            {isUserPermitted("expert_logic_edit") && (
              <div className="">
                <button
                  type="button"
                  className="btn bg-colored-reverse text-white fw-bold rounded-pill p-2 px-4"
                  onClick={async () => {
                    if (
                      (await confirmDialog(
                        "Remove project",
                        `Are you sure you want to remove this project?`
                      )) === false
                    ) {
                      return;
                    }
                    setLoading(true);
                    await deleteProject({ id: project.ID }).then((res) => {
                      if ("data" in res) {
                        toast.success("Project deleted successfully");
                      }
                      setTimeout(() => {
                        if ("data" in res) {
                          navigate("/library/logic");
                        }
                        setLoading(false);
                      }, 700);
                    });
                  }}
                  disabled={loading}
                >
                  Delete Project
                  {loading ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />
                  ) : (
                    ""
                  )}
                </button>
              </div>
            )}
          </div>
        </>
      )}

      <JsonCollapse json={project} />
    </div>
  );
}
